import React from "react";

function ReuestTrainer() {
  return <div className="text-center mt-5">Comming Soon..!</div>;
}

export default ReuestTrainer;
